module.exports = __webpack_public_path__ + "media/images/pic/image-e82cd80748100843b8d81ea652d29ff7.jpeg";